import React from "react";

const HomeIconV2 = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2551_844"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2551_844)">
        <path
          d="M13.125 21.25H16.875V18.125H20V14.375H16.875V11.25H13.125V14.375H10V18.125H13.125V21.25ZM5 26.25V11.25L15 3.75L25 11.25V26.25H5ZM7.5 23.75H22.5V12.5L15 6.875L7.5 12.5V23.75Z"
          fill="#03579E"
        />
      </g>
    </svg>
  );
};

export default HomeIconV2;
